<template>
    <div class="video-upload-box clearfix">
        <div class="image fl">
            <el-image 
                :src="url && cover" 
                fit="contain" 
                v-loading="uploadLoading" 
            >
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
            <div v-if="urlFull" class="tool">
                <div>
                    <span class="img-preview el-icon-video-play" @click="preview"></span>
                    <el-button v-if="!disabled" icon="el-icon-delete" type="text" @click="remove"></el-button>
                </div>
            </div>
        </div>
        <div class="video-upload-content">
            <ul>
                <li>
                    <i :class="formatVerified | verified"></i>
                    格式: <slot name="type">支持格式为{{ acceptText }}</slot>
                </li>
                <li>
                    <i :class="bytesVerified | verified"></i>
                    大小: 大小不超过100M
                </li>
            </ul>
            <template v-if="progress && progress < 100 && uploadLoading">
                <el-progress :percentage="progress"></el-progress>
            </template>
            <div class="video-upload-btn" >
                <el-upload
                    action
                    :accept="accept"
                    :http-request="uploadFile"
                    :show-file-list="false"
                    :disabled="uploadLoading"
                    :before-upload="beforeUpload"
                >
                    <el-button type="primary" icon="el-icon-upload" size="small" :disabled="disabled"
                        >{{url ? '重新上传' : '点击上传'}}</el-button
                    >
                </el-upload>
            </div>
        </div>
        <VideoPlay ref="videoPlay"></VideoPlay>
    </div>
</template>

<script>
import {uploadVideo} from '@/assets/js/commonApi.js';
import VideoPlay from "@/components/VideoPlay"
export default {
    filters: {
        verified(v) {
            if (v === null) {
                return ["el-icon-warning-outline"];
            } else if (v === false) {
                return ["el-icon-circle-close", "error"];
            } else {
                return ["el-icon-circle-check", "success"];
            }
        },
    },
    props:{
        //封面
        cover: {
            type: String,
            default: () => "",
        },
        // 视频相对路径
        url: {
            type: String,
            default: () => "",
        },
        // 视频全路径
        urlFull: {
            type: String,
            default: () => "",
        },
        accept:{
            type: String,
            default: 'video/mp4',
        },
        //是否禁用
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components:{VideoPlay},
    data() {
        return {
            uploadLoading: false,
            formatVerified: null,
            bytesVerified: null,
            progress: null,
        };
    },
    computed: {
        acceptText(){
             return this.accept.split(',').map(item => item.split('/')[1].toLocaleUpperCase()).toString();
        },
    },
    methods: {
        async beforeUpload(file){
            //格式检查
            let _accept = this.accept.split(',') || [];
            _accept.map( (item,index) => {
                _accept[index] = item.trim();
            })
            this.formatVerified = _accept.find( v => v == file.type);
            if (!this.formatVerified) {
                this.$message.error("文件格式错误,请重新上传");
                //return;
            }
            //大小检查
            this.bytesVerified = file.size / 1024 / 1024 < 100;
            if (!this.bytesVerified) {
                this.$message.error("文件大小错误,请重新上传");
                //return;
            }

            return this.formatVerified && this.bytesVerified;
        },

        setProgress(ev){
            this.progress = Math.floor((ev.loaded / ev.total) * 20);
            if(Math.floor((ev.loaded / ev.total)) == 1){
                let t = setInterval(() => {
                    if(this.progress < 99 && this.uploadLoading) {
                        this.progress += 1;
                    }else{
                        clearInterval(t);
                    }
                },1000)
            }
        },

        async uploadFile(req) {
            if( this.formatVerified && this.bytesVerified){
                let res;
                this.uploadLoading = true;
                const formData = new FormData();

                this.progress = 0;

                const {
                    file
                } = req;

                formData.append("file", file || req);

                res = await uploadVideo(formData,ev => {
                    this.setProgress(ev);
                }).catch(() => {
                    this.$message.error( '上传失败');
                }).finally(() => {
                    this.progress = 99;
                    setTimeout( () => {this.uploadLoading = false;},800);
                }) 

                const {state,result,msg} = res.data;
                if(state == 1){
                    this.$emit(
                        "update:url",
                        result.url
                    );
                    this.$emit(
                        "update:urlFull",
                        result.urlFull
                    ); 

                    this.$emit('onSuccess',req,result)

                }else{
                    this.$message.error( msg || '上传失败');
                }
            }
        },
        //清除
        remove(){
            this.$emit(
                "update:url",""
            );
            this.$emit(
                "update:urlFull",""
            );
            this.formatVerified = this.bytesVerified =  null;
        },
        //预览
        preview(){
            this.$refs.videoPlay.show({ url: this.urlFull })
        },

    }
}
</script>

<style lang="scss" scoped>
.video-upload-box {
    .image {
        width: 200px;
        height: 200px;
        margin-right: 15px;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
        border-radius: 8px;
        position: relative;
        overflow: hidden;
        .el-image{
            width: 100%;
            height: 100%;
        }
        .tool{
            position: absolute;
            background: rgba(0,0,0,0.5);
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            display: none;
            align-items: center;
            justify-content: center;
            .el-button,.img-preview{
                color: #ffffff;
                font-size: 18px;
                font-weight: 700;
                margin: 0 5px;
            }
            .img-preview{
                cursor: pointer;
            }
        }
        &:hover{
            .tool{
                display: flex;
            }
        }
    }
    .video-upload-content {
        overflow: hidden;
        position: relative;
        height: 200px;
        ul {
            li {
                line-height: normal;
                color: #999;
                margin-bottom: 5px;
                font-size: 13px;
                i {
                    &.error {
                        color: #f56c6c;
                    }

                    &.success {
                        color: #67c23a;
                    }
                }
            }
        }
        .video-upload-btn{
            position: absolute;
            left: 0px;
            bottom: 0px;
            width: 100%;
            ::v-deep .el-upload {
                width: 150px;
                .el-button {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }
}

</style>